import { Box, Container, Grid, Link, Stack, Typography } from "@mui/material";
import React from "react";
import logoFooter from "../assets/img/logo-footer.png"
import CompanyInfo from "./CompanyInfo";

const FooterSection = () => {
  // Footer data structure for mapping
  const footerLinks = [
    // {
    //   category: "Company",
    //   links: ["About Us", "Our Team", "Careers", "Press"],
    // },
    // {
    //   category: "Resources",
    //   links: ["Documentation", "Tutorials", "FAQs", "Blog"],
    // },
    {
        category: "Helpful",
        links: [["Privacy policy","/privacy-policy"], ["Refund policy","/refund-policy"], ["Terms and condition","/terms-and-condition"]]
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "black",
        pt: 15,
        pb: 10,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={12.5}>
          <Grid item xs>
            <Grid container spacing={3.75}>
              {footerLinks.map((column, index) => (
                <Grid item xs key={index}>
                  <Stack spacing={1.5}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#a1a09f",
                        fontFamily: "'Inter-Regular', Helvetica",
                        fontSize: "12px",
                        lineHeight: "15px",
                      }}
                    >
                      {column.category}
                    </Typography>

                    {column.links.map((link, linkIndex) => (
                      <Link
                        key={linkIndex}
                        href={link[1]}
                        underline="none"
                        sx={{
                          color: "#a1a09f",
                          fontFamily: "'Space Grotesk-Regular', Helvetica",
                          fontSize: "16px",
                          lineHeight: "16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {link[0]}
                      </Link>
                    ))}
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <CompanyInfo/>
        </Grid>
        <Grid item sx={{marginTop: "20px"}}>
            <Stack spacing={2.5}>
              <Typography
                variant="body2"
                sx={{
                  color: "#a1a09f",
                  fontFamily: "'Space Grotesk-Regular', Helvetica",
                  lineHeight: "16px",
                }}
              >
                © 2025 Arkyn-tech
                <br />
                All rights reserved.
              </Typography>
            </Stack>
          </Grid>
      </Container>
    </Box>
  );
};

export default FooterSection;